export default 
[
    {
        path: 'benchmark/',
        name: 'crisis-benchmark',
        component: () => import('@/views/crisis/Benchmark.vue') 
    },
];